// extracted by mini-css-extract-plugin
export var alertIcon = "_nu-0";